$( function(){

  $('[data-search-mobile]').on('click', (event) => {
      event.preventDefault();
      $('body').addClass('open_search_mobile');
  });
  $('[data-search-close-sidebar], .background-overlay').on('click', (event) => {
      event.preventDefault();
      $('body').removeClass('open_search_mobile');
  });
  
  $('.devShowMoreContent mb').on('click', function(){
    $(this).parent().prev().toggleClass('open');
    $(this).hide();
  });

  $('.devShowMoreFaq mb').on('click', function(){
    $(this).parent().prev().find('.devCollabsibleGridInner').toggleClass('open');
    $(this).hide();
  });

  $('.devColTit').on('click', function(){
    $('.devColDesc').slideToggle();
  });

  $('.devMenu').on('click', function(){
    $('.devmegamenuMain').addClass('showMenu');
    $('body').addClass('devOverFlowHidden');
  });

  $(document).on('click', '.mobileMenu-toggle', function(e){
    e.preventDefault();
    $('.devmegamenuMain').addClass('showMenu');
    $('body').addClass('devOverFlowHidden');
  });

  $(".devmegamenuMain").on('click', function () {
    $('.devmegamenuMain').removeClass('showMenu');
    $('body').removeClass('devOverFlowHidden');
  }).children().on('click', function (e) {
      e.stopPropagation();
  });

  $(".crossbutton").on('click', function (e) {
      e.stopPropagation();
      $('.devmegamenuMain').removeClass('showMenu');
      $('body').removeClass('devOverFlowHidden');
  });
  
  $('.devParent').on('click', function(e){
    e.preventDefault();
    if ($(this).text().indexOf('Collections') === -1) {
      $('.devCenterTitle').text( $(this).text() );
      $('.devSubCenterTitle').text( $(this).text() );
    }
    $(this).next().next().toggleClass('showSubMenu');
    $('.devBackMenu').show();
    $('.logotext').hide();
  });

  $('.devParentSvg').on('click', function(e){
    e.preventDefault();
    $(this).prev().trigger('click');
  });

  $('.devBackMenu').on('click', function(e){
    $('.showSubMenu').removeClass('showSubMenu');
    $(this).hide();
    $('.logotext').show();
    $('.devCenterTitle').text('');
    $('.devSubCenterTitle').text('');
  });



  const sliders = document.querySelectorAll('.drag-scroll');

  sliders.forEach(slider => {
    let isDown = false;
    let startX;
    let scrollLeft;
  
    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('dragging');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      e.preventDefault();
    });
  
    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('dragging');
    });
  
    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('dragging');
    });
  
    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = x - startX;
      slider.scrollLeft = scrollLeft - walk;
    });
  });
  


  $('button.halo-popup-close.devThankyouBtn').on('click', function(){
    $(".halo-newsletter-popup .halo-popup-close").trigger('click');
  });

  $('.footerItem').closest('a').addClass('devContactChatbtn active');

  $('.devContactChatbtn.active').on('click', function(e){
    e.preventDefault();
  });



  (function() {
    function onTidioChatApiReady() {
          window.tidioChatApi.hide();
        }

        if (window.tidioChatApi) {
          window.tidioChatApi.on("ready", onTidioChatApiReady);
        }

        document.querySelector(".devContactChatbtn.active").addEventListener("click", function() {
        window.tidioChatApi.show();
        window.tidioChatApi.open();
    });
  })();

     

  (function() {
    function onTidioChatApiReady() {
          window.tidioChatApi.hide();
        }

        if (window.tidioChatApi) {
          window.tidioChatApi.on("ready", onTidioChatApiReady);
        }

        document.querySelector(".devContactChatbtn").addEventListener("click", function() {
        window.tidioChatApi.show();
        window.tidioChatApi.open();
    });
  })();


// (function waitForCollectionInput() {

//     var input = document.querySelector('input[name="custom_Collection"]');

//     if (!input) {
//         setTimeout(waitForCollectionInput, 300);
//         return;
//     }

//     console.log('Omnisend input found');

//     document.addEventListener('click', function (e) {

//         var btn = e.target.closest('button[type="button"]');
//         if (!btn) return;

//         var value = btn.textContent.trim();

  
//         input.value = value;
//         input.setAttribute('value', value);

  
//         input.dispatchEvent(new Event('input', { bubbles: true }));
//         input.dispatchEvent(new Event('change', { bubbles: true }));

//         console.log('Collection saved:', value);
//     });

// })();


// $('.omnisend-form-6964cae8c33e003b9647a273-field-container-696a1713af156defee5e5cdf-field-wrapper label').on('click', function(){
//   console.log('label working');
//   $('div#omnisend-form-6964cae8c33e003b9647a273-field-648c46db5aad81dc3539ba15').css('display', 'none');
// });

(function waitForCollectionRadios() {

  var $radios = $('input[name="custom_Collection"]');

  if (!$radios.length) {
    setTimeout(waitForCollectionRadios, 300);
    return;
  }

  console.log('Collection radios found');

  $(document).on('change', 'input[name="custom_Collection"]', function () {

    // if ANY radio is checked
    if ($('input[name="custom_Collection"]:checked').length) {
      $('#omnisend-form-6964cae8c33e003b9647a273-field-648c46db5aad81dc3539ba15')
        .css('display', 'block'); // or 'none'
        $('.omnisend-form-6964cae8c33e003b9647a273-field-container-696a1713af156defee5e5cdf').css('display', 'none');
        $('.omnisend-form-6964cae8c33e003b9647a273-action-64393c9bfafe8595962af781').css('display', 'block');
    }
    

  });

})();









});





